import { AI_FIRESTORE_COLLECTION } from '@/config';
import { sendContentReportError } from '@/store/actions';

import { filter, last, drop, map, forEach } from 'lodash';
import { firestore } from '../firebase';

export function getHistories(date, userId) {
  const docRef = firestore.collection(AI_FIRESTORE_COLLECTION).doc('monitoring').collection(date).doc(userId);
  return docRef.get().then((doc) => {
    if (doc.exists) {
      return doc.data().data || [];
    }
    return [];
  }).catch(() => []);
}

export function updateHistory(date, userId, histories) {
  const limitHistories = 100;
  const docRef = firestore.collection(AI_FIRESTORE_COLLECTION).doc('monitoring').collection(date).doc(userId);
  const payload = { data: histories, id: userId };

  if (histories && histories.length > limitHistories) {
    payload.data = drop(histories, histories.length - limitHistories);
  }

  return docRef.set(payload, { merge: true })
    .then(() => true)
    .catch(() => false);
}

function fetchCoreConceptScoreFromFirestore(userId, coreConceptId) {
  const ref = firestore.collection(AI_FIRESTORE_COLLECTION).doc('core-concept-progress').collection(userId).doc(coreConceptId.toString());
  return ref.get().then((doc) => {
    if (doc.exists) {
      return doc.data().score || 0;
    }
    return 0;
  }).catch(() => (0));
}

function getCoreConceptScore(quizResults, userId, coreConceptId) {
  const correctQuizResultsCount = filter(quizResults, 'is_correct').length;

  let score = Math.min(80, (100 * (correctQuizResultsCount / quizResults.length)));
  if (correctQuizResultsCount >= 5 && correctQuizResultsCount === quizResults.length) {
    score = 100;
  }

  if (correctQuizResultsCount === quizResults.length && quizResults < 5) {
    return fetchCoreConceptScoreFromFirestore(userId, coreConceptId)
      .then(previousScore => Promise.resolve(Math.max(score, previousScore)));
  }
  return Promise.resolve(score);
}

function updateConceptAchievement(userId, coreConceptId, quizResults) {
  const lastQuizResult = last(quizResults);
  const proficiencyScore = lastQuizResult.proficiency_score || 0;

  const ref = firestore.collection(AI_FIRESTORE_COLLECTION).doc('core-concept-progress').collection(userId).doc(coreConceptId.toString());

  return getCoreConceptScore(quizResults, userId, coreConceptId)
    .then((score) => {
      const payload = { score, proficiency_score: proficiencyScore };
      return ref.set(payload, { merge: true })
        .then(() => true)
        .catch(() => false);
    });
}

export function updateAchievement(userId, cat, coreConceptIds, quizResults) {
  if (coreConceptIds.length !== quizResults.length) {
    const params = {
      cat_id: cat.id,
      msg: 'cat의 핵심개념 리스트와과 결과데이터의 개수가 다름',
    };

    sendContentReportError({}, params);
    return;
  }

  const coreConceptResultsMap = {};
  forEach(coreConceptIds, (coreConceptId, index) => {
    const results = coreConceptResultsMap[coreConceptId] || [];
    results.push(quizResults[index]);
    coreConceptResultsMap[coreConceptId] = results;
  });

  map(coreConceptResultsMap, (v, k) => {
    updateConceptAchievement(userId, k, v);
  });
}
